/**
 * api前缀
 */
export const API_PREFIX = '/baldr'

/**
 * 国家电话码
 * @wiki http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=114390267
 */
export const COUNTRY_CALLING_CODE = '+52'

/**
 * 地区码
 * @wiki http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=114390267
 */
export const COUNTRY_ID = 484

/**
 * 地区简写
 * @wiki http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=114390267
 */
export const CANONICAL_COUNTRY_CODE = 'MX'

export const FAQ_URL =
  'http://manhattan.webapp.xiaojukeji.com/service/faq/home?productId=juxiangka'

/**
 * 性别
 */
export const GENDER = {
  MAN: 1,
  WOMAN: 2,
}

/**
 * 品牌名
 */
export const BRAND_NAME_CARD = 'DiDi Card'

/**
 * 埋点枚举
 */
export const KEY_TYPE = {
  KEY_POINT: 1,
  NOT_KEY_POINT: 0,
}

// 滴滴公司名
export const DIDI_COMPANY_NAME = 'DiDi'

// 翻译时app传参
export const APP_VALUES = {
  DIDI: 'DiDi',
  DIDIFOOD: 'DiDi Food',
  DIDIFINANZAS: 'DiDi Finanzas',
  FINANZASAPP: 'DiDi Finanzas',
  DIDICARD: 'DiDi Card',
  BRANDNAME: 'DiDi Card',
  AMOUNT: 'MXN$20,000'
}
/**
 * 品牌名称
 */
export const BRAND_NAME = 'DiDi Card'

/**
 * 外投路由名称
 */
export const MARKET_NAME = 'market'


export const MARKET_SDK_CHANNEL = {
  google: 'google',
  tiktok: 'tiktok',
  meta: 'meta',
    ec: 'ec'
}

export const EXTERNAL_CHANNEL = {
  mgm: 'MGM',
  google: 'Google',
  meta: 'Meta',
  tiktok: 'Tiktok',
  web: 'Website',
    ec: 'EC',
  other: 'externalDefault'
}

// 埋点-申请渠道参数
export const APPLY_SOURCE = {
  MGM: 'MGM', // mgm
  WEB: 'WEB', // 官网
  OUT: 'OUT', // 外投
  DEFAULT: '' // 默认
}

// 埋点公参 - 设备类型
export const DEVICE_TYPE = {
  MOBILE: 'mobile',
  PC: 'pc'
}

// 埋点-按钮参数
export const BUTTON_NAME = {
  DOWNLOAD: 'download',
  GOAPP: 'go_app',
  DIDI: 'didi',
  FOOD: 'food'
}

export const CHANNEL_TYPE = {
  MGM: 'mgm',
  WEBSITE: 'website'
}

// 埋点 输入是否粘贴
export const INPUT_TYPE = {
  manual: 'manual',
  copy: 'copy'
}

// 登录页埋点
export const LOGIN_BUTTON_NAME = {
  phone: 'phone_number_input',
  next: 'next',
  check: 'check',
  uncheck: 'uncheck',
  view_agreement: 'view_agreement'
}

// 端外申卡标识
export const EXTERNAL_APPLY_CHANNEL = 9

// 端外营销标识 - 营销活动
export const EXTERNAL_MARKET_PAGE = 'web-marketing'

// 端外营销标识 - W2A页面
export const EXTERNAL_W2A_PAGE = 'web2app'

export const APP_CURP_CHANGE = {
   //乘客端
   PASSENGERS:'',
   //独立端
   FINTECH:'https://oia.didiglobal.com/dlc/Cz4GLL'
}

export const APP_TERMINAL= {
   //乘客端
   GLOBAL_PASSENGER_APP:'GLOBAL_PASSENGER_APP',
   //独立端
   FINTECH_APP:'FINTECH_APP'
}

//唤起端默认链接
export const DEFAULT_APP_URL= {
   //乘客端
  PASSENGER_APP:"https://d.didiglobal.com/78xK",
   //独立端
  FINTECH_APP:"https://d.didiglobal.com/7u3Z",
   //外卖端
  FOOD_APP:"https://d.didiglobal.com/7iBv",
}

